"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplyRequestParameter = void 0;
/**
 * A record of a request for a medication, substance or device used in the healthcare setting.
 */
var SupplyRequestParameter = /** @class */ (function () {
    function SupplyRequestParameter() {
    }
    return SupplyRequestParameter;
}());
exports.SupplyRequestParameter = SupplyRequestParameter;
